import { useState, useEffect } from "react";
import "./Navbar.css";

const Navbar = () => {
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const [isScrolled, setIsScrolled] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            setIsScrolled(window.scrollY > 50);
        };

        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    const toggleMenu = () => {
        setIsMenuOpen(!isMenuOpen);
    };

    return (
        <nav className={`navbar ${isScrolled ? "scrolled" : ""}`}>
            <div className="navbar-container">
                <a href="/" className="navbar-logo">
                    <img src={require("../../../Assets/Images/commissh_white_logo.png")} className="navbar-logo" alt="Commissh" />
                </a>
                <div className={`navbar-menu ${isMenuOpen ? "active" : ""}`}>
                    <a href="/" className="navbar-item">
                        Home
                    </a>
                    {/* <a href="/ticket-giveaway" className="navbar-item">
                        Ticket Giveaway
                    </a> */}
                    <a href="/about-us" className="navbar-item">
                        About Us
                    </a>
                    <a href="/contact" className="navbar-item">
                        Contact
                    </a>
                    {/* <a href="/careers" className="navbar-item">
                        Careers
                    </a> */}
                    {/* <button className="navbar-button mobile" onClick={handleDownload}>
                        Download the App
                    </button> */}
                </div>
                <div className="navbar-button-placeholder"></div>
                {/* <button className="navbar-button desktop" onClick={handleDownload}>
                    Download the App
                </button> */}
                <div className="navbar-burger" onClick={toggleMenu}>
                    <span></span>
                    <span></span>
                    <span></span>
                </div>
            </div>
        </nav>
    );
};

export default Navbar;
